import track from '@relx/shence';
import { TGetGps } from './types';
import { wx } from 'umi';

const getGps: TGetGps = () => {
  return new Promise(async (resLocation, rejLocation) => {
    wx.ready().then(() => {
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02',
        cancel(err: any) {
          rejLocation(err);
          track.biz('reject_location_permission');
        },
      } as any)
        .then(gps => {
          if (gps.latitude && gps.longitude) {
            track.biz('approve_location_permission');
            resLocation({
              lat: gps.latitude,
              lng: gps.longitude,
            });
          } else {
            track.biz('wx_location_incomplete', {
              lat: gps.latitude,
              lng: gps.longitude,
            });
            rejLocation({
              errMsg: '经纬度不全',
            });
          }
        })
        .catch(error => {
          track.biz('location_fail_wx', {
            reason: typeof error === 'object' ? JSON.stringify(error) : error,
          });
          rejLocation(error);
        });
    });
  });
};

export default getGps;
//   track.biz('location_fail', { reason: e.errMsg });
//   rejLocation('获取地理定位失败');
